import * as React from 'react';
import FaChevronCircleRight from 'react-icons/fa/chevron-circle-right';
import FaPhone from 'react-icons/fa/phone';
import { find, flow, forEach, startCase } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { IChannel, IPremium, IProduct } from '../../../../data/api/models';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import SaveQuoteModal from '../../components/SaveQuoteModal';
import { IQuoteState } from '../../../../services/quote/models';
import SidebarQuoteSummary from './components/SidebarQuoteSummary';
import BenefitsSection from '../../components/BenefitsSection';
import { IStore } from '../../../../redux/IStore';
import { reduxForm } from 'redux-form';
import SecurePaymentSvg from './components/SecurePaymentSvg/SecurePaymentSvg';
import { withRouter } from 'react-router';

interface IQuoteSidebarProps {
  quote: IQuoteState;
  product: IProduct;
  channel: IChannel;
  location: any;
}

class QuoteSidebar extends React.Component<IQuoteSidebarProps> {

  private get isAdditionalCover() {
    const { quote } = this.props;
    const STEP = 'additionalCover';
    const isAdditionalCover = find(quote.application.steps, (element) => element === STEP);
    return !!isAdditionalCover;
  }

  private get isSelectCover() {
    const { location } = this.props;
    const targetUrl = '/scheme-choice';
    return targetUrl === location.pathname;
  }

  private renderYourQuote = () => {
    const { quote, channel } = this.props;

    const quotes = quote.quotes;
    const schemeId = quote.application.schemeId;
    const isAgg = channel.channelType === 'AGG';

    if (Object.keys(quotes).length === 0) {
      return null;
    }

    let premium: IPremium = null;

    forEach(quotes, (tripTypes) => {
      forEach(tripTypes, (quotedPremium) => {
        if (!quotedPremium.scheme) {
          return null;
        }

        if (quotedPremium.scheme.id === schemeId) {
          premium = quotedPremium;
        }
      });
    });

    const customClassList = ['tpl-b2c', 'mpt-b2c'];
    const isOnList = customClassList.includes(channel.key);
    const tripType = premium && premium.information.tripType === 'single' ? 'Single Trip' : 'Annual Multi-trip';
    const infoContainerClass = ['info-container', isOnList ? 'info-container--top' : ''].join(' ');
    const renderChevronCircle = channel.key !== 'tpl-b2c' ? <FaChevronCircleRight/> : null;
    const infoTitleClass = ['info-title', isOnList ? 'info-title--noBorder' : ''].join(' ');

    return (
      <div>
        {premium && (
        <div className={infoContainerClass}>
          <div className={infoTitleClass}>
            {renderChevronCircle}
            {quote.complete ? 'Your Policy' : 'Your Quote'}
          </div>
          {isAgg && (
            <p className="info-product-cover-level">
              {tripType} {startCase(premium && premium.scheme.coverLevel.replace('_', ' '))}
            </p>
          )}
          {premium && (
            <div className="quote-main-details">
              <h1>
                <FormattedNumber
                  value={premium.gross}
                  style="currency"
                  currency={premium.currency}
                />
              </h1>
              <h5>
                {quote.complete  ? ('Total Paid') : ('Total Price')}
              </h5>
              <p>inc. Insurance Premium Tax (IPT) if applicable</p>
            </div>
          )}
          {!quote.complete && !isAgg && !this.isSelectCover && (
            <Row>
              <Col sm={12}>
                <SaveQuoteModal {...this.props}/>
              </Col>
            </Row>
          )}
        </div>
        )}
      </div>
    );
  }

  private renderQuoteBenefits = () => {
    const { channel } = this.props;

    if (channel.channelType === 'AGG') {
      return (
        <BenefitsSection />
      );
    }

    return null;
  }

  private renderQuoteSummary = () => {
    const { quote, product, channel } = this.props;
    const quotes = quote.quotes;
    const schemeId = quote.application.schemeId;

    if (! quotes) {
      return null;
    }

    let premium: IPremium = null;

    forEach(quotes, (tripTypes, level) => {
      forEach(tripTypes, (quotedPremium) => {
        if (!quotedPremium) {
          return null;
        }

        if (quotedPremium.scheme.id === schemeId) {
          premium = quotedPremium;
        }
      });
    });

    if (quote.complete) {
      return null;
    }

    return (
      <div>

        <SidebarQuoteSummary
          product={product}
          channel={channel}
          isCoverChoice={this.isCoverChoice}
          isAdditionalCover={this.isAdditionalCover}
        />
      </div>
    );
  }

  private renderInfoContainer = () => {
    const { channel } = this.props;

    const policyDocument = find(channel.productDocuments, (document) => {
      return document.shortName === 'Insurance Policy';
    });

    return (
      <div className="info-container">
        <div className="info-title">
          <FaChevronCircleRight className="side-bar-color"/>
          Information
        </div>
        <Row>
          <Col sm={6} md={12} xs={6}>
            <a
              className="info-links"
              href={policyDocument ? policyDocument.filePath : ''}
              target="_blank"
            >
              Insurance Policy
            </a>
            {channel.channelType !== 'AGG' && (
              <a
                className="info-links"
                href={channel.urls.faq}
                target="_blank"
              >
                Frequently Asked Questions
              </a>
            )}
            <a
              className="info-links"
              href={channel.urls.keyFeatures}
              target="_blank"
            >
              Key Features
            </a>
          </Col>
          <Col md={12} sm={6} xs={6}>
            <Row className="secure-payment-container">
              <Col sm={6}>
                Buy With Confidence
              </Col>
              <Col sm={6}>
                <SecurePaymentSvg />
              </Col>
            </Row>
            <div className="payment-options">
              <img src={require('./img/cc1.jpg')} alt="card"/>
              <img src={require('./img/cc2.jpg')} alt="card"/>
              <img src={require('./img/cc3.jpg')} alt="card"/>
              <img src={require('./img/cc4.jpg')} alt="card"/>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  private renderPhoneAndOpeningHours = () => {
    const { channel } = this.props;

    return (
      <div className="phone-and-opening-hours">
        <div className="icon">
          <FaPhone/>
        </div>
        <a href={`tel:${channel.phone}`} className="phone">
          {channel.phone}
        </a>
        <div className="opening-hours">
          {channel.openingHours}
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div className="quote-sidebar">
        {this.renderYourQuote()}
        {this.renderQuoteBenefits()}
        {this.renderQuoteSummary()}
        {this.renderInfoContainer()}
        {this.renderPhoneAndOpeningHours()}
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: 'quote-sidebar',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (state: IStore) => ({
      quote: state.quote,
      channel: state.branding.channel,
    }),
  ),
  withRouter,
])(QuoteSidebar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/QuoteSidebar/index.tsx